<template>
  <div class="orderRenewal-list">
    <el-tabs v-model="activeTabName" type="card" @tab-click="handleTabClick">
      <el-tab-pane
        v-for="item in tabList"
        :key="item.value"
        :label="item.label"
        :name="item.value"
      ></el-tab-pane>
    </el-tabs>
    <keep-alive>
      <base-list-management
        v-if="activeTabName === tabMap.personal.value"
        ref="baseListManagement"
        :configData.sync="personalConfigData"
        :key="0"
      >
        <div slot="custom-operate">
          <el-button type="primary" @click="handelAddOrderRenewal"
            >发起订单续约</el-button
          >
        </div>
      </base-list-management>

      <base-list-management
        v-if="activeTabName === tabMap.enterprise.value"
        ref="baseListManagement"
        :configData.sync="enterpriseConfigData"
        :key="1"
      >
        <div slot="custom-operate">
          <el-button type="primary" @click="handelAddOrderRenewal"
            >发起订单续约</el-button
          >
        </div>
      </base-list-management>

      <base-list-management
        v-if="activeTabName === tabMap.enterpriseSub.value"
        ref="baseListManagement"
        :configData.sync="enterpriseSubConfigData"
        :key="2"
      >
        <div slot="custom-operate">
          <el-button type="primary" @click="handelAddOrderRenewal"
            >发起订单续约</el-button
          >
          <el-button type="primary" @click="handelBatchAddOrderRenewal"
            >批量订单续约</el-button
          >
        </div>
      </base-list-management>
    </keep-alive>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import {
  FuzzySearch as gerCarList,
} from '@/api/domain/cars'
import { searchByCustomerNameSensitive } from '@/api/domain/customers'
import { parseQueryJsonStr } from '@/utils/querySchema'
import { ORDER_TYPES } from '@/pages/orders/orderRenewal/config'
import {
  TAB_MAP,
  TAB_LIST,
  PERSONAL_ADD_PATH,
  ENTERPRISE_ADD_PATH,
  ENTERPRISE_SUB_ADD_PATH,
  ENTERPRISE_SUB_BATCH_ADD_PATH,
  CONFIG,
} from '@/pages/orders/orderRenewal/list/config'

export default {
  data() {
    const { query: queryStr } = this.$route?.query
    const queryObj = queryStr ? parseQueryJsonStr(queryStr) : {}
    const { personalConfigData, enterpriseConfigData, enterpriseSubConfigData } = CONFIG.call(this)
    return {
      personalConfigData,
      enterpriseConfigData,
      enterpriseSubConfigData,
      activeTabName: queryObj.tab || TAB_MAP.personal.value,
      tabMap: JSON.parse(JSON.stringify(TAB_MAP)),
      tabList: JSON.parse(JSON.stringify(TAB_LIST)),
      queries: queryObj,
    }
  },
  methods: {
    init() {
      this.getRouteQuery()
    },
    getRouteQuery() {
      const { tab = '', search = {} } = this.queries
      const { gmtCreate = '', deptId = '' } = search

      if (gmtCreate !== '') {
        if (tab === TAB_MAP.personal.value) {
          this.personalConfigData.formData.formProps.model.gmtCreate = gmtCreate
        } else if (tab === TAB_MAP.enterpriseSub.value) {
          this.enterpriseSubConfigData.formData.formProps.model.gmtCreate =
            gmtCreate
        }
      }
      if (deptId !== '') {
        if (tab === TAB_MAP.personal.value) {
          this.personalConfigData.formData.formProps.model.deptIdList = [
            Number(deptId),
          ]
        } else if (tab === TAB_MAP.enterpriseSub.value) {
          this.enterpriseSubConfigData.formData.formProps.model.deptIdList = [
            Number(deptId),
          ]
        }
      }
    },
    // 获取车辆列表-mixin 有引用
    // eslint-disable-next-line vue/no-unused-properties
    async gerCarList(query) {
      query = query.trim()

      let carList

      if (query.length >= 4) {
        this.$refs.baseListManagement?.setItemData({
          elConfigKey: 'loading',
          key: 'carId',
          data: true,
        })
        try {
          const { code, data } = await gerCarList({
            plateNo: query,
            state: 1,
          })
          if (code === 1) {
            carList = data
          }
          this.$refs.baseListManagement?.setItemData({
            elConfigKey: 'loading',
            key: 'carId',
            data: false,
          })
        } catch (err) {
          this.$refs.baseListManagement?.setItemData({
            elConfigKey: 'loading',
            key: 'carId',
            data: false,
          })
        }
      } else {
        carList = []
      }

      this.$refs.baseListManagement?.setItemData({
        elConfigKey: 'list',
        key: 'carId',
        data: carList,
      })
    },
    // 获取客户列表
    // eslint-disable-next-line vue/no-unused-properties
    async getCustomerList(query) {
      let customerIdList = []
      if (query.length > 1) {
        this.$refs.baseListManagement?.setItemData({
          elConfigKey: 'loading',
          key: 'customerId',
          data: true,
        })
        try {
          const { code, data = [] } = await searchByCustomerNameSensitive({
            customerName: query,
            customerType:
              this.activeTabName === this.tabMap.personal.value ? 1 : 2,
          })
          if (code === 1) {
            customerIdList = data
          }
          this.$refs.baseListManagement?.setItemData({
            elConfigKey: 'loading',
            key: 'customerId',
            data: false,
          })
        } catch (_) {
          this.$refs.baseListManagement?.setItemData({
            elConfigKey: 'loading',
            key: 'customerId',
            data: false,
          })
        }
      }

      this.$refs.baseListManagement?.setItemData({
        elConfigKey: 'list',
        key: 'customerId',
        data: customerIdList,
      })
    },
    // eslint-disable-next-line vue/no-unused-properties
    dealWithSearchOfPersonnal(params) {
      const _params = JSON.parse(JSON.stringify(params))

      const customerId = _params.customerId ? _params.customerId : null
      const carId = _params.carId ? _params.carId : null
      const newOrderId = _params.newOrderId
        ? parseInt(_params.newOrderId)
        : null
      const oldOrderId = _params.oldOrderId
        ? parseInt(_params.oldOrderId)
        : null
      const gmtCreateStart = _params?.gmtCreate?.[0] || ''
      const gmtCreateEnd = _params?.gmtCreate?.[1] || ''

      const renewalStartTimeStart = _params?.renewalStartTime?.[0] || ''
      const renewalStartTimeEnd = _params?.renewalStartTime?.[1] || ''

      const renewalEndTimeStart = _params?.renewalEndTime?.[0] || ''
      const renewalEndTimeEnd = _params?.renewalEndTime?.[1] || ''

      delete _params.gmtCreate
      delete _params.renewalStartTime
      delete _params.renewalEndTime

      const { brandSeriesModel } = _params
      const brandId = brandSeriesModel.brandId
      const seriesId = brandSeriesModel.seriesId
      const modelId = brandSeriesModel.modelId

      delete _params.brandSeriesModel

      return {
        ..._params,
        customerId,
        carId,
        modelId,
        newOrderId,
        oldOrderId,
        gmtCreateStart,
        gmtCreateEnd,
        renewalStartTimeStart,
        renewalStartTimeEnd,
        renewalEndTimeStart,
        renewalEndTimeEnd,
        orderType: ORDER_TYPES.personal.value,
        brandId,
        seriesId,
      }
    },
    // eslint-disable-next-line vue/no-unused-properties
    dealWithSearchOfEnterprise(params) {
      const _params = JSON.parse(JSON.stringify(params))

      const orderId = _params.orderId ? parseInt(_params.orderId) : null
      const customerId = _params.customerId ? _params.customerId : null

      const createStartTime = _params?.createTime?.[0] || ''
      const createEndTime = _params?.createTime?.[1] || ''

      const startRenewalEndDate = _params?.renewalEndDate?.[0] || ''
      const endRenewalEndDate = _params?.renewalEndDate?.[1] || ''

      delete _params.createTime
      delete _params.renewalEndDate

      return {
        ..._params,
        orderId,
        customerId,
        createStartTime,
        createEndTime,
        startRenewalEndDate,
        endRenewalEndDate,
      }
    },
    // eslint-disable-next-line vue/no-unused-properties
    dealWithSearchOfEnterpriseSub(params) {
      const _params = JSON.parse(JSON.stringify(params))

      const customerId = _params.customerId ? _params.customerId : null
      const carId = _params.carId ? _params.carId : null
      const newOrderId = _params.newOrderId
        ? parseInt(_params.newOrderId)
        : null
      const oldOrderId = _params.oldOrderId
        ? parseInt(_params.oldOrderId)
        : null

      const gmtCreateStart = _params?.gmtCreate?.[0] || ''
      const gmtCreateEnd = _params?.gmtCreate?.[1] || ''

      const renewalStartTimeStart = _params?.renewalStartTime?.[0] || ''
      const renewalStartTimeEnd = _params?.renewalStartTime?.[1] || ''

      const renewalEndTimeStart = _params?.renewalEndTime?.[0] || ''
      const renewalEndTimeEnd = _params?.renewalEndTime?.[1] || ''

      delete _params.gmtCreate
      delete _params.renewalStartTime
      delete _params.renewalEndTime
      const { brandSeriesModel } = _params
      const brandId = brandSeriesModel.brandId
      const seriesId = brandSeriesModel.seriesId
      const modelId = brandSeriesModel.modelId

      delete _params.brandSeriesModel
      return {
        ..._params,
        customerId,
        carId,
        modelId,
        newOrderId,
        oldOrderId,
        gmtCreateStart,
        gmtCreateEnd,
        renewalStartTimeStart,
        renewalStartTimeEnd,
        renewalEndTimeStart,
        renewalEndTimeEnd,
        orderType: ORDER_TYPES.enterprise.value,
        brandId,
        seriesId,
      }
    },
    resetBaseListManagement() {
      try {
        this.$refs.baseListManagement?.reset()
      } catch (err) {
        console.log(err)
      }
    },
    /* eslint-disable-next-line vue/no-unused-properties */
    resetBrandSeriesModel() {
      this.$refs.baseListManagement?.setItemData({
        elConfigKey: 'value',
        key: 'brandSeriesModel',
        data: {},
      })
    },
    handleTabClick() {
      try {
        this.resetBaseListManagement()
      } catch (err) {
        console.log(err)
      }
    },
    handelAddOrderRenewal() {
      let url
      if (this.activeTabName === this.tabMap.personal.value) {
        url = PERSONAL_ADD_PATH
      } else if (this.activeTabName === this.tabMap.enterprise.value) {
        url = ENTERPRISE_ADD_PATH
      } else if (this.activeTabName === this.tabMap.enterpriseSub.value) {
        url = ENTERPRISE_SUB_ADD_PATH
      }
      this.$router.push(url)
    },
    handelBatchAddOrderRenewal() {
      this.$router.push(ENTERPRISE_SUB_BATCH_ADD_PATH)
    },
  },
  mounted() {
    this.init()
  },
}
</script>
